import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { EditTagComponent } from './edit-tag/edit-tag.component';
import { NewTagComponent } from './new-tag/new-tag.component';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';
import { DeleteTagComponent } from './delete-tag/delete-tag.component';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';

@Component({
    selector: 'app-manage-tags',
    templateUrl: './manage-tags.component.html',
    styleUrls: ['./manage-tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageTagsComponent implements OnInit {
  @Input() data: any;
  allTagsList: any;
  loading: boolean = false;
  clientId: any;
  deleteTag_name: any;
  deleteTag_color: any;
  deleteTag_id: any;
  searchText: string = '';

  pageStart: number = 0;
  pageHeight: number = 100;
  pageEnd: number = 50;
  pageBuffer: number = 20;

  constructor(
    private modalService: NgbModal,
    private cookies: CookieService,
    private reportService: ReportsService,
    private activeModal: NgbActiveModal,
    private sweetAlertService: SweetAlertService,

  ) { }

  ngOnInit(): void {

    const encryptedUserSession = localStorage.getItem('encryptedUserSession');

    if (encryptedUserSession) {
      const decryptedStr = decryptPledgeData(encryptedUserSession);
      const decryptedData = JSON.parse(decryptedStr);
      this.clientId = decryptedData.accountId;    
    }
    this.getAllTags();
    
  }

  getAllTags() {
    //this.loading = true;
    this.reportService.getTags(this.clientId).subscribe({
      next: (data) => {
        this.loading = false;
        if (data) {
          this.allTagsList = data;    
        }
      },
      error: () => {
        this.loading = false;
      }
    })
  }

  closeModel() {
    this.activeModal.close('success');
  }

  tagsAnalyseDirect() {
    this.modalService.dismissAll();
   }

  editTag(data: any) {
    const dialogRef: NgbModalRef = this.modalService.open(EditTagComponent, { centered: true, size: 'md',  backdrop: 'static',
            keyboard: false,
            windowClass: 'force-close-modal',
            backdropClass: 'force-close-backdrop', });
    dialogRef.componentInstance.data = {
      tagData: data,
    };
    dialogRef.result.then(
      (result) => {
        // console.log('Modal closed with result: ', result); 
        if (result === 'success') {
          this.getAllTags();
        }
      },
      (reason) => {
       // console.log('Modal dismissed with reason: ', reason);
       this.getAllTags();
      }
    );
  }
  
  newTag() {
    const dialogRef: NgbModalRef = this.modalService.open(NewTagComponent, { centered: true, size: 'md',  backdrop: 'static',
            keyboard: false,
            windowClass: 'force-close-modal',
            backdropClass: 'force-close-backdrop', });
    dialogRef.result.then(
      (result) => {
        //console.log('Modal closed with result: ', result); 
        if (result === 'success') {
          this.getAllTags();
        }
      },
      (reason) => {
       // console.log('Modal dismissed with reason: ', reason);
      }
    );
  }

  deleteTag(deleteTag: any) {
    const dialogRef: NgbModalRef = this.modalService.open(DeleteTagComponent, { centered: true, size: 'sm',  backdrop: 'static',
            keyboard: false,
            windowClass: 'force-close-modal',
            backdropClass: 'force-close-backdrop', });
    dialogRef.componentInstance.deleteTag = {
      getDeleteTag: deleteTag,
    };
    dialogRef.result.then(
      (result) => {
        //console.log('Modal closed with result: ', result); 
        if (result === 'success') {
          this.getAllTags();
        }
      },
      (reason) => {
       //console.log('Modal dismissed with reason: ', reason);
       this.getAllTags();
      }
    );
  }

  onScroll(event: any) {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const offsetHeight = event.target.offsetHeight;
    const scrollPosition = scrollTop + offsetHeight;
    const scrollTreshold = scrollHeight - this.pageHeight;
    if (scrollPosition > scrollTreshold) {
      this.pageEnd += this.pageBuffer;
    }
  }

}